import { render, staticRenderFns } from "./MockCandidateGenerationConfig.vue.vue?vue&type=template&id=6221fb18&scoped=true&"
import script from "./MockCandidateGenerationConfig.vue.vue?vue&type=script&lang=ts&"
export * from "./MockCandidateGenerationConfig.vue.vue?vue&type=script&lang=ts&"
import style0 from "./MockCandidateGenerationConfig.vue.vue?vue&type=style&index=0&id=6221fb18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6221fb18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
